export const isValidCoordinate = (coord: number | null | undefined): boolean => {
  return coord !== null && coord !== undefined && !isNaN(coord);
};

export const isLatitude = (value: string | undefined) => {
  return value !== undefined && value !== '' && (Number.isFinite(Number(value)) && Math.abs(Number(value)) <= 90);
};

export const isLongitude = (value: string | undefined) => {
  return value !== undefined && value !== '' && (Number.isFinite(Number(value)) && Math.abs(Number(value)) <= 180);
};

export const isValidLatLong = (latitude: number, longitude: number) => isLatitude(latitude.toString()) && isLongitude(longitude.toString());

export const adjustOutOfBoundsCoordinates = (lat: number, lng: number) => {
  if (lng > 180) {
    lng = lng % 360 - 360;
  } else if (lng < -180) {
    lng = lng % 360 + 360;
  }

  if (lat > 90) {
    lat = 90;
  } else if (lat < -90) {
    lat = -90;
  }

  return { lng, lat };
};
